import {PixelRatio, View} from 'react-native';
import * as React from 'react';

import {useStyles} from '../../hooks/styles';
import {images} from '../../../assets/icons';
import {useTheme} from '../../theme';

type Props = {
  backgroundColor: string;
  color?: string;
  size?: number;
};

const DEFAULT_SIZE = 20;

export const ExclamationInCircle: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  const color = props.color ? props.color : theme.color.grayMenu;
  const styles = useStyles(({align}) => {
    const size = props.size ? props.size : align(DEFAULT_SIZE);
    const symbolSize = PixelRatio.roundToNearestPixel(size * 0.5);
    return {
      block: {
        backgroundColor: props.backgroundColor,
        borderRadius: size,
        width: size,
        height: size,
        alignItems: 'center',
        justifyContent: 'center',
      },
      symbolSize: {
        width: '100%',
        height: symbolSize,
      },
    };
  });
  return (
    <View style={styles.block}>
      <images.Exclamation color={color} strokeWidth={0} {...styles.symbolSize} />
    </View>
  );
};
